import React from "react";
import { Link } from 'react-router-dom';
import {
    Col,
    Table,
    Row
} from 'reactstrap';
import TableHeader from './TableHeader';
import TableData from './TableData';
import TableLoader from './TableLoader';
import AkPagination from '../AkPagination'
import './table.scss';
import DownloadReport from './DownloadReport';
import { SearchIcon } from "../Icon";

interface Props {
    data: any | undefined;
    fetching?: boolean;
    type?: string;
    client_code?: any;
    token?: any;
    history?: any;
    count?: number | undefined;
    editInvoice?: Function;
    deleteInvoice?: Function;
    fetchNewData: Function;
    downloadInvoice?: (params: any) => void;
    tableHeader: any;
    loginData?: any;
    handleSearch: (e: any) => void;
    pagination?: any;
    updatePagination: (data: any) => void;
}

interface State {
    activePage: number;
    // count       : number;
    limit: number;
    pageNumber: number;
    startCount: number;
    endCount: number;
    prev: boolean;
    next: boolean;
}
class AkTable extends React.Component<Props, State>{
    updateState = (data: any) => {

        this.setState(data)
    }

    render() {
        const {
            data = [],
            fetching,
            count,
            editInvoice,
            deleteInvoice,
            tableHeader,
            fetchNewData,
            downloadInvoice,
            client_code,
            type,
            history,
            loginData,
            pagination,
            updatePagination
        } = this.props;


        return (
            <>
                <Row >
                    <Col lg={4}>
                        <AkPagination
                            className={"mt-1 mb-1"}
                            fetchData={fetchNewData}
                            updateState={updatePagination}
                            count={count}
                            limit={pagination.limit}
                            startCount={pagination.startCount}
                            endCount={pagination.endCount}
                            pageNumber={pagination.pageNumber}
                            next={pagination.next}
                            prev={pagination.prev}
                            history={history}

                        />
                    </Col>

                    <Col lg={8} className="text-right d-flex flex-row" style={{ justifyContent: 'flex-end' }}>
                        <div className="mr-3 w-auto position-relative">
                            <span style={{ position: 'absolute', top: '8px', left: '13px' }}>
                                <SearchIcon />
                            </span>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Search (Min. 3 char)"
                                onChange={(e: any) => this.props.handleSearch(e)}
                                style={{ paddingLeft: '35px' }}
                            />
                        </div>
                        <Link to={`/invoice/bulk-upload/${ client_code }?type=${ type }`} className="btn btn-outline-info mr-2" style={{ width: '165px' }}>
                            <i className="fas fa-file-upload"></i>&nbsp;Bulk&nbsp;Upload
                        </Link>
                        <div className="ml-2">
                            <DownloadReport
                                downloadInvoice={downloadInvoice}
                                client_code={client_code}
                                type={type}
                            />
                        </div>
                    </Col>

                </Row>
                {fetching ? <TableLoader
                    Rows={10}
                    ColumnPerRow={5}
                />
                    :
                    <Row>
                        <Col xs="12">
                            <div className="table-bordered">
                                <Table className=" ">
                                    <thead>
                                        <TableHeader
                                            tableHeader={tableHeader}
                                        />
                                    </thead>
                                    <tbody>
                                        <TableData
                                            data={data}
                                            tableHeader={tableHeader}
                                            editEntry={editInvoice}
                                            deleteEntry={deleteInvoice}
                                            loginData={loginData}
                                        />
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                }
            </>
        )

    }
}

export default AkTable;